
/* tslint:disable */
const templateData = `
<div class="error-page">
    <div class="error-page-container">
        <div class="error-type">{{::'public.error.404.type' | translate}} | <span>{{::'public.error.404.type.text' | translate}}<span></div>
        <div class="error-title">{{::'public.error.404.title' | translate}}</div>
        <div class="error-redirect">{{::'public.error.redirected' | translate}} <go-home-counter></go-home-counter>...</div>
        <a class="icon icon-home home-link" inner-link="/">{{::'public.error.home.btn' | translate}}</a>
    </div>
</div>

`;
export = templateData;
